/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M5.25 4.25H24v1.5H6.75v3.5H24v1.5H1.5v12.5H4l.0002-3h1.5l-.0002 3h1.4998l.0002-3h1.5l-.0002 3H11l.0002-3h1.5l-.0002 3h1.4998l.0002-3h1.5l-.0002 3H18l.0002-3h1.5l-.0002 3h1.4998l.0002-3h1.5l-.0002 3H24v1.5H0V9.25h5.25v-5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 13.25h4.5v4.5H4v-4.5Zm1.5 1.5v1.5H7v-1.5H5.5ZM11 13.25v4.5h4.5v-4.5H11Zm1.5 3v-1.5H14v1.5h-1.5ZM18 13.25h4.5v4.5H18v-4.5Zm1.5 1.5v1.5H21v-1.5h-1.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'RAM'
);
